import {useDashboard} from '../../../hooks/kpi/useDashboard'
import {ChartsDistractsPerPeriod} from './componente/charts/ChartsDistractsPerPeriod'

interface SalesProps {
  className: string
}

export function DistractsPerPeriod({className}: SalesProps) {
  const {query} = useDashboard()

  const distractsPerPeriod = query.data?.distractsPerPeriod?.itens ?? {
    name: '',
    series: [],
    categories: [],
  }
  const totalPriceDistractsPerPeriod = query.data?.distractsPerPeriod?.total ?? 0
  const isLoading = query.isLoading

  return (
    <div className={`card card-flush ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Distrato de produtos</span>

          <span className='text-muted fw-semibold fs-7'>Itens cancelado(s)</span>
        </h3>
      </div>

      {isLoading && (
        <div className='card-body pt-1 pb-4 d-flex flex-wrap flex-center p-4 px-10'>
          <div className='d-flex flex-center w-100'>
            <div className='text-center w-100 align-items-center justify-content-center'>
              <span>Carregando...</span>
            </div>
          </div>
        </div>
      )}
      {!isLoading && (
        <div className='card-body pt-1 pb-4 d-flex flex-wrap flex-start p-4 px-10'>
          <div className='d-flex flex-center w-100'>
            <ChartsDistractsPerPeriod
              className='w-100 h-100'
              distractsPerPeriod={distractsPerPeriod}
              totalPriceDistractsPerPeriod={totalPriceDistractsPerPeriod}
            />
          </div>
        </div>
      )}
    </div>
  )
}
